/**
 * @fileoverview gRPC-Web generated client stub for pbs
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var common_pb = require('./common_pb.js')
const proto = {};
proto.pbs = require('./upload_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.pbs.UploadServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.pbs.UploadServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.UploadReq,
 *   !proto.pbs.UploadResp>}
 */
const methodDescriptor_UploadService_Upload = new grpc.web.MethodDescriptor(
  '/pbs.UploadService/Upload',
  grpc.web.MethodType.UNARY,
  proto.pbs.UploadReq,
  proto.pbs.UploadResp,
  /**
   * @param {!proto.pbs.UploadReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.UploadResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.UploadReq,
 *   !proto.pbs.UploadResp>}
 */
const methodInfo_UploadService_Upload = new grpc.web.AbstractClientBase.MethodInfo(
  proto.pbs.UploadResp,
  /**
   * @param {!proto.pbs.UploadReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.UploadResp.deserializeBinary
);


/**
 * @param {!proto.pbs.UploadReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.UploadResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.UploadResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UploadServiceClient.prototype.upload =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UploadService/Upload',
      request,
      metadata || {},
      methodDescriptor_UploadService_Upload,
      callback);
};


/**
 * @param {!proto.pbs.UploadReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.UploadResp>}
 *     A native promise that resolves to the response
 */
proto.pbs.UploadServicePromiseClient.prototype.upload =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UploadService/Upload',
      request,
      metadata || {},
      methodDescriptor_UploadService_Upload);
};


module.exports = proto.pbs;

